module.exports = __webpack_public_path__ + "img/marker.40e7f134.png";